import { useTranslation } from "react-i18next";
import Card from "../../../components/card/Card";
import Button from "../../../components/shared/ui/Button/baseBtn";
import { useDevices } from "../../../context/DeviceProvider";
import { formatdDate } from "../../../lib/utils";

export default function DevaiceDetails({
    openDeleteModal,
    openConectionSettings
}: {
    openConectionSettings: () => void,
    openDeleteModal: () => void
}) {
    const { t } = useTranslation()

    const i18nDeviceDirectory = (key: string): string =>
        t(`device-details.${key}`);

    const { deviceDetail, pingDevice, getDeviceList, activateDevice } = useDevices()

    const handlePing = () => {
        if (deviceDetail?.id) {
            pingDevice(deviceDetail?.id)
        }
    }
    const handleActivate = async () => {
        if (deviceDetail?.id) {
            activateDevice(deviceDetail.id)
            await getDeviceList()
        }
    }
    return (
        <div className="relative h-full">
            <div className="h-[calc(100%-64px)] overflow-auto flex flex-col justify-between ">
                <div className="flex flex-col gap-2 my-2 mx-4">
                    <Card
                        title={i18nDeviceDirectory("generalInformation")}
                        items={[
                            {
                                label: i18nDeviceDirectory("name"),
                                value: deviceDetail?.name
                            },
                            {
                                label: i18nDeviceDirectory("manufacturer"),
                                value: deviceDetail?.manufacturer
                            },
                            {
                                label: i18nDeviceDirectory("model"),
                                value: deviceDetail?.model
                            },
                            {
                                label: i18nDeviceDirectory("location"),
                                value: deviceDetail?.department
                            },
                            {
                                label: i18nDeviceDirectory("dateAdded"),
                                value: formatdDate(deviceDetail?.created_stamp)
                            },
                            {
                                label: i18nDeviceDirectory("addedBy"),
                                // @ts-ignore
                                value: deviceDetail?.added_by,
                            }
                        ]}
                    />

                    <Card
                        titleClass='flex items-center justify-between bg-background-light-gray'
                        icon="settings"
                        onClick={openConectionSettings}
                        title={i18nDeviceDirectory("connectionAndStatus")}
                        items={[
                            {
                                label: i18nDeviceDirectory("ipAddress"),
                                value: deviceDetail?.config?.ip_address
                            },
                            {
                                label: i18nDeviceDirectory("portNumber"),
                                value: deviceDetail?.config?.port
                            },
                            {
                                label: i18nDeviceDirectory("deviceProtocol"),
                                value: deviceDetail?.config?.protocol
                            },
                            {
                                label: i18nDeviceDirectory("lastHealthCheck"),
                                value: formatdDate(deviceDetail?.last_health_check),
                            },
                            {
                                label: i18nDeviceDirectory("lastStatusUpdate"),
                                // @ts-ignore
                                value: formatdDate(deviceDetail?.applied_at),
                            },
                            {
                                label: i18nDeviceDirectory("status"),
                                value: deviceDetail?.status,
                            }
                        ]}
                    />
                </div>
            </div>

            <div className="w-full h-[64px] flex border-t bg-white p-3 gap-2 z-50 justify-end">
                {
                    deviceDetail?.status == 'active' ?
                        <Button
                            variant="warning"
                            type="submit"
                            size="sm"
                            onClick={openDeleteModal}
                        >
                            {i18nDeviceDirectory("deactivate")}
                        </Button> :
                        <Button
                            variant="outline"
                            type="submit"
                            size="sm"
                            onClick={handleActivate}
                        >
                            {i18nDeviceDirectory("activate")}
                        </Button>
                }
                <Button
                    type="submit"
                    size="sm"
                    onClick={handlePing}
                >
                    {i18nDeviceDirectory("pingDevice")}
                </Button>
            </div>
        </div>
    )
}
